import { useEffect, useRef, useState } from 'react'
import { useClickAway } from 'react-use'

import { FaqSearchRequest, strapi } from 'api'
import { Form, useForm } from 'components/form'
import { SearchFormField } from 'components/form-field'
import { yup } from 'components/form/yup'
import { cn } from 'utils'
import { FormNameType } from 'utils/types'
import { useTypeaheadAsyncSearch } from 'utils/use-typeahead-async-search'

import { Result } from './Result'
import styles from './faq-search.module.css'

const FIELD: FormNameType<FaqSearchRequest> = {
  query: 'query',
}

const SCHEMA = yup.object().shape({
  [FIELD.query]: yup.string().trim(),
})

export const FaqSearch = () => {
  const formMethods = useForm<FaqSearchRequest>(SCHEMA, {})
  const [open, setOpen] = useState<boolean>(false)
  const block = useRef<HTMLDivElement>(null)

  useClickAway(block, () => setOpen(false))

  const { search, searching, results, typing, isDirty } = useTypeaheadAsyncSearch(
    strapi.faqs.search,
  )

  useEffect(() => {
    const subscription = formMethods.watch(({ query = '' }) => search(query))
    return () => subscription.unsubscribe()
  }, [formMethods, search])

  const handleSubmit = () => {}

  return (
    <div className={styles.block} ref={block}>
      <Form formMethods={formMethods} onSubmit={handleSubmit}>
        <SearchFormField
          name={FIELD.query}
          placeholder="Type a question or search by a keyword"
          className={styles.searchInputContainer}
          onFocus={() => setOpen(true)}
          fullWidth
          classNameIcon={styles.icon}
          formMethods={formMethods}
        />
        <div className={cn(styles.results, open && styles.open, searching && styles.searching)}>
          <Result typing={typing} searching={searching} data={results} isDirty={isDirty} />
        </div>
      </Form>
    </div>
  )
}
